import trackingRequest from '@/models/trackingRequest'
import shipment from '@/models/shipment'

function prepare (data) {
  data.carrier = data.carrier_id
  data.project = data.project_id
  return data
}

export default {
  namespaced: true,
  state: {
    currentPage: 1,
    count: 0
  },
  actions: {
    async list ({ dispatch, state }, params) {
      return dispatch('list', {modelClass: trackingRequest, params: params}, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    },
    async retrieve ({ dispatch, state }, id) {
      return dispatch('retrieve', { modelClass: trackingRequest, id: id }, { root: true })
        .then(response => { return response })
        .catch(error => { throw error })
    },
    async save ({ dispatch, state }, data) {
      return dispatch('save', { modelClass: trackingRequest, data: prepare(data), duration: 7000 }, { root: true })
        .then(response => { state.object = response })
        .catch(error => { throw error })
    },
    async patch ({ dispatch, state }, data) {
      var id = data.id
      data.id = undefined
      return dispatch('partialUpdate', { modelClass: trackingRequest, id: id, data: data, duration: 7000 }, { root: true })
        .then(response => { state.object = response })
        .catch(error => { throw error })
    },
    async export ({ dispatch, state }, params) {
      return dispatch(
        'download',
        {
          method: 'get',
          params: params,
          url: `tracking-requests/export`
        }, { root: true })
        .then(response => { return response })
        .catch(error => { throw error })
    },
    async setClientCode ({ dispatch, state }, data) {
      return dispatch(
        'save', {
          action: 'set_client_code',
          modelClass: trackingRequest,
          id: data.id,
          data: {
            'client_code': data.client_code
          }
        }, { root: true })
        .then(response => { state.object = response })
        .catch(error => { throw error })
    },
    async transition ({ dispatch, state }, data) {
      return dispatch('save', {
        action: 'transition',
        modelClass: trackingRequest,
        id: data.id,
        data: { 'status': data.newStatus }
      }, { root: true })
        .then(response => { return response })
        .catch(error => { throw error })
    },
    async shipments ({ dispatch, state }, {id, params}) {
      var ModelClass = shipment
      return this.dispatch('request', {
        method: 'get',
        url: `tracking-requests/${id}/shipments`,
        params: params
      })
        .then(response => {
          var count = 'count' in response.data ? response.data.count : response.data.length
          var results = 'results' in response.data ? response.data.results : response.data
          var resultDict = { count: count, results: [] }
          results.forEach(element => {
            resultDict.results.push(new ModelClass(element))
          })
          return resultDict
        }).catch(error => {
          throw error
        })
    },
    async uploadBulk  ({ dispatch, state }, data) {
      return dispatch('request', { method: 'put', url: 'upload/bulk-import-tracking-requests/bulk', data: data, noSlash: true, duration: 7000 }, { root: true })
        .then(response => { return response.data })
        .catch(error => { throw error })
    },
    async retry  ({ dispatch, state }, id) {
      return dispatch('request', { method: 'post', url: `tracking-requests/${id}/retry`, duration: 7000 }, { root: true })
        .then(response => { return response.data })
        .catch(error => { throw error })
    }
  },
  getters: {
    objects (state) { return state.objects }
  }
}



// WEBPACK FOOTER //
// ./src/store/trackingRequest.js